import { useState } from 'react';
import {
  Modal,
  Typography,
  TextArea,
  IconButton,
  Icon,
} from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import approveIcon from 'assets/icons/approve.svg';

type ApproveRequestModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onApproveRequest: ({ comments }: { comments?: string | undefined }) => void;
};

const ApproveRequestModal = ({
  isOpen,
  onCancel,
  onApproveRequest,
}: ApproveRequestModalProps) => {
  const [comments, setComments] = useState<string>();

  const handleClose = () => {
    onCancel();
    setComments('');
  };

  const handleApproveRequest = () => {
    onApproveRequest({ comments });
  };

  return (
    <Modal
      aria-label='approve-request-modal'
      actionButtons={[
        {
          children: intl.get(
            'REQUESTS_LIST_PAGE.MODAL.APPROVE_REQUEST.APPROVE_REQUEST'
          ),
          variant: 'primary',
          onClick: handleApproveRequest,
          'data-cy': 'request-approval-button',
          className: 'h-10',
        },
        {
          children: intl.get(
            'REQUESTS_LIST_PAGE.MODAL.DELETE_REQUEST.CANCEL_BUTTON'
          ),
          variant: 'tertiary',
          onClick: handleClose,
          'data-cy': 'request-approval-cancel-button',
          className: 'h-10',
        },
      ]}
      data-testid='approve-request-modal'
      closeModal={handleClose}
      isOpen={isOpen}
      size='medium'
    >
      <div className='relative mb-4'>
        <IconButton
          onClick={handleClose}
          className='absolute top-0 right-0 text-primary-dark'
          aria-label={intl.get('CLOSE') || 'Close'}
          data-cy='close-modal-button'
          name='close'
        />
        <div className='flex items-center gap-2'>
          <Icon src={approveIcon} className='w-5 h-5' />
          <Typography
            className='text-lg font-normal leading-[28px]'
            data-cy='change-form-button'
          >
            {intl.get(
              'REQUESTS_LIST_PAGE.MODAL.APPROVE_REQUEST.APPROVE_REQUEST'
            )}
          </Typography>
        </div>
      </div>

      <TextArea
        label={intl.get('REQUESTS_LIST_PAGE.MODAL.APPROVE_REQUEST.COMMENTS')}
        textAreaProps={{
          placeholder: intl.get(
            'REQUESTS_LIST_PAGE.MODAL.APPROVE_REQUEST.DETAILS'
          ),
          'data-cy': 'field_approve-request-comments',
        }}
        value={comments}
        onChange={(event) => setComments(event.target.value)}
      />
    </Modal>
  );
};

export default ApproveRequestModal;
